module.exports = __webpack_public_path__ + "static/media/lightbulb-on.4137f992.svg";